import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { isBroker } from './agent';
import { getAgentExperience } from './getAgentExperience';
import { getAgentMarketExperience } from './getAgentMarketExperience';
import { getSubAgentExperience } from './getSubAgentExperience';
import { isFakeSubAgent } from './isFakeSubAgent';

/**
 * Формируем текст опыта агента
 * 'На рынке с ....' или 'Опыт работы: с ...'
 * @param agent IAgentSchema
 * @param offer IOfferSchema
 */
export function getExperienceText(agent: IAgentSchema, offer: IOfferSchema) {
  if (agent.isSubAgent) {
    return getSubAgentExperience(agent);
  }

  if (isBroker(agent) || agent.isDeveloper || isFakeSubAgent(agent, offer)) {
    return getAgentExperience(agent);
  }

  return getAgentMarketExperience(agent);
}
